import { render, staticRenderFns } from "./ProgressFollowed.vue?vue&type=template&id=d944037e&scoped=true&"
import script from "./ProgressFollowed.vue?vue&type=script&lang=js&"
export * from "./ProgressFollowed.vue?vue&type=script&lang=js&"
import style0 from "./ProgressFollowed.vue?vue&type=style&index=0&id=d944037e&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d944037e",
  null
  
)

export default component.exports